var React = require('react');

function CtaRightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.125 16L6.715 14.59L12.295 9L0.125 9L0.125 7L12.295 7L6.705 1.42L8.125 -3.49691e-07L16.125 8L8.125 16Z","fill":"#242424"}));
}

CtaRightArrow.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = CtaRightArrow;

CtaRightArrow.default = CtaRightArrow;
